module.exports = __webpack_public_path__ + "static/img/surpass_limit.d11a2255.png";